import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { InquiryModal } from './components/forms/InquiryModal';
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { ApplicationsPage } from './pages/ApplicationsPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { LegalPage } from './pages/LegalPage';
import { ServicePage } from './pages/ServicePage';
import { LanguageProvider } from './lib/i18n';
export function App() {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [preselectedProductId, setPreselectedProductId] = useState<string | undefined>();
  const handleRequestQuote = (productId?: string) => {
    setPreselectedProductId(productId);
    setIsInquiryModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsInquiryModalOpen(false);
    setPreselectedProductId(undefined);
  };
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen flex flex-col bg-dark-bg" data-id="element-2">
          <Header onRequestQuote={() => handleRequestQuote()} data-id="element-3" />
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage onRequestQuote={() => handleRequestQuote()} data-id="element-6" />} data-id="element-5" />
            <Route path="/products" element={<ProductsPage onRequestQuote={() => handleRequestQuote()} data-id="element-8" />} data-id="element-7" />
            <Route path="/products/:slug" element={<ProductDetailPage data-id="element-10" />} data-id="element-9" />
            <Route path="/applications" element={<ApplicationsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/about" element={<AboutPage data-id="element-14" />} data-id="element-13" />
            <Route path="/contact" element={<ContactPage data-id="element-16" />} data-id="element-15" />
            <Route path="/legal" element={<LegalPage data-id="element-18" />} data-id="element-17" />
            <Route path="/servis" element={<ServicePage data-id="element-20" />} data-id="element-19" />
          </Routes>
          <Footer data-id="element-21" />
          <InquiryModal isOpen={isInquiryModalOpen} onClose={handleCloseModal} preselectedProductId={preselectedProductId} data-id="element-22" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}